import React, { useCallback, useEffect, useRef, useState } from "react";
import { Card, CardContent } from "semantic-ui-react";
import Tab from "../../components/Tab";
import { Search, File } from "react-feather";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import SearchDropdown from "../../components/input/SearchDropdown";
import Button from "../../components/input/Button";
import LoadingSpinner from "../../components/LoadingSpinner";
import Grid from "../../components/Grid";
import {
  DateCellRenderer,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import {
  createDDN,
  generateDDNSearch,
  getDDNById,
  searchDDN,
} from "../../api/documentDeliveryNoteApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import SideDrawer from "../../components/input/SideDrawer";
import DocumentDeliveryNoteDrawer from "../../components/mis/DocumentDeliveryNoteDrawer";

function DocumentDeliveryNote() {
  const user = useSelector((state) => state.user);
  const [tab, setTab] = useState(1);
  const [activeAccordion, setActiveAccordion] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [generateClicked, setGenerateClicked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [customer, setCustomer] = useState(null);
  const [ddnCustomer, setDDNCustomer] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [fromDateDDN, setFromDateDDN] = useState(null);
  const [toDateDDN, setToDateDDN] = useState(null);
  const [dateType, setDateType] = useState(1);
  const [dateTypeDDN, setDateTypeDDN] = useState(1);
  const [module, setModule] = useState(null);
  const [documentType, setDocumentType] = useState(1);
  const [documentTypeDDN, setDocumentTypeDDN] = useState(1);
  const [documentCategory, setDocumentCategory] = useState("");
  const [department, setDepartment] = useState(null);
  const [referenceNo, setReferenceNo] = useState(null);
  const [referenceNoDDN, setReferenceNoDDN] = useState(null);
  const [attentionPerson, setAttentionPerson] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");

  const [status, setStatus] = useState(2);
  const [active, setActive] = useState(1);
  const [searchDdnId, setSearchDdnId] = useState("");

  const [dateTypeOptions, setDateTypeOptions] = useState([]);
  const [moduleOptions, setModuleOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [singleBulkOptions, setSingleBulkOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);

  const [generateResult, setGenerateResult] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [byIdResult, setByIdResult] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [errors, setErrors] = useState({});

  const gridRef = useRef();
  const sideRef = useRef();

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const {
        date_types: dateTypeData,
        service_type: serviceTypeData,
        ddn_doc_type: moduleTypeData,
        single_bulk: singleBulkData,
        status: statusData,
        active: activeData,
      } = await getBulkDropdownData([
        { key: "date_types" },
        { key: "ddn_doc_type" },
        { key: "service_type" },
        { key: "single_bulk" },
        { key: "status" },
        { key: "active" },
      ]);

      setDateTypeOptions(dateTypeData);
      setModuleOptions(serviceTypeData);
      setDocumentTypeOptions(moduleTypeData);
      setSingleBulkOptions(singleBulkData);
      setStatusOptions(statusData);
      setActiveOptions(activeData);
      setIsLoading(false);
    })();
  }, []);

  const handleSearch = async () => {
    setSearchClicked(true);
    setIsLoading(true);
    const searchPayload = {
      documentType: documentTypeDDN,
      invoiceNo: referenceNoDDN,
      billingCustomer: documentType === 2 ? ddnCustomer : null,
      transporterId: documentType === 3 ? ddnCustomer : null,
      dateType,
      dateTypeDDN,
      fromDate: fromDateDDN,
      toDate: toDateDDN,
    };
    try {
      const response = await searchDDN(searchPayload);
      setSearchResult(response);
    } catch (error) {
      console.log(error);
      setSearchClicked(false);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const handleGenerate = async () => {
    setGenerateClicked(true);
    setIsLoading(true);
    const newErrors = {};
    if (!documentType) newErrors.documentType = "Document Type is required";
    if ((documentType === 1 || documentType === 2) && !customer) newErrors.stakeholder = "Stakeholder is required";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setIsLoading(false);
      setGenerateClicked(false);
      return;
    }
    const payload = {
      documentType,
      documentCategory,
      eihId: referenceNo,
      stakeholder: customer,
      dateType,
      fromDate,
      toDate,
    };
    try {
      const result = await generateDDNSearch(payload);
      setGenerateResult(result);
    } catch (e) {
      console.log(e);
      setGenerateClicked(false);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const handleSelectionChanged = useCallback(() => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
  });

  const handleSubmitGenerate = async () => {
    const newErrors = {};
    if (!attentionPerson)
      newErrors.attentionPerson = "Attention Person is required";
    if (!email) newErrors.email = "Email is required";
    if (selectedRows.length === 0)
      newErrors.selectedRows = "Select at least one row";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill required fields and select at least one row");
      return;
    }

    const ddnDetails = selectedRows.map((row) => ({
      ddndHeader: null,
      ddndDocumentType: documentType,
      ddndInvoiceAmount: row.eihwith_tax || 0,
      ddndDocumentId: row.eihid,
      ddndStatus: 1,
      ddndActive: 1,
      createdBy: user.username,
    }));

    const payloadGenerate = {
      ddnAttentionPerson: attentionPerson,
      ddnEmail: email,
      ddnDescription: description,
      ddnTotal: ddnDetails.reduce(
        (sum, item) => sum + parseFloat(item.ddndInvoiceAmount),
        0
      ),
      ddnStatus: 1,
      ddnActive: 1,
      createdBy: user.username,
      deliveryNoteDetailRequests: ddnDetails,
    };

    try {
      const response = await createDDN(payloadGenerate);
      if (response.status === 200) {
        toast.success(`Successfully Generated ${response?.data?.ddnCode}`, {
          autoClose: 5000,
          containerId: "Main",
        });
        // Reset form or UI state here
        setSelectedRows([]);
        setAttentionPerson("");
        setEmail("");
        setDescription("");
      } else {
        toast.error("Failed to generate DDN");
      }
    } catch (error) {
      console.error("DDN generation error:", error);
      toast.error("An error occurred while generating DDN");
    }
  };

  const handleRowDoubleClick = async (params) => {
    console.log(params.data);
    try {
      const response = await getDDNById(params.data.ddnId);
      // Merge additional fields from params.data into the result
      const mergedResult = {
        ...response.data,
        customerName: params.data.customerName,
        eihInvCustomer: params.data.eihInvCustomer,
        eihTransporter: params.data.eihTransporter,
        invoiceCodes: params.data.invoiceCodes,
        invCustAddress: params.data.invCustAddress,
        invoiceIds:params.data.invoiceIds
      };
      setByIdResult(mergedResult);
      if (response.status === 200) {
        setIsDrawerOpen(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const handleReset = () => {
    setCustomer(null);
    setFromDate("");
    setToDate("");
    setDateType(1);
    setModule(null);
    setDocumentType(1);
    setDDNCustomer(null);
    setDocumentTypeDDN(1);
    setFromDateDDN("");
    setToDateDDN("");
    setReferenceNoDDN("");
    setDocumentCategory("");
    setDepartment(null);
    setReferenceNo(null);
    setAttentionPerson("");
    setEmail("");
    setDescription("");
    setSearchDdnId("");
    setReferenceNo("");
    setStatus(2);
    setActive(1);
    setResetSearchFields(true);
    setGenerateClicked(false);
    setSearchClicked(false);
  };

  return (
    <>
      <Card style={{ width: "100%" }}>
        <CardContent>
          <div
            className="ui attached tabular"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div className="ui tabular menu top attached">
              <Tab
                Icon={File}
                onClick={() => {
                  setTab(1);
                  setActiveAccordion(1);
                  setSearchClicked(false);
                  setDocumentType(1);
                  setResetSearchFields(true);
                }}
                active={tab === 1}
                label={"DDN Generate"}
              />
              <Tab
                Icon={Search}
                onClick={() => {
                  setTab(2);
                  setActiveAccordion(2);
                  setGenerateClicked(false);
                  setDocumentTypeDDN(1);
                  setResetSearchFields(true);
                }}
                active={tab === 2}
                label={"DDN Search"}
              />
            </div>
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ display: tab === 1 ? "block" : "none" }}
          >
            <div
              className="ui styled accordion"
              style={{ width: "100%", marginBottom: "10px" }}
            >
              <div className={`title ${activeAccordion === 1 ? "active" : ""}`}>
                <div>
                  Generate
                  <File size={14} style={{ marginLeft: "10px" }} />
                  <i className="dropdown icon"></i>
                </div>
              </div>
              <div
                className={`content ${activeAccordion === 1 ? "active" : ""}`}
              >
                <form className="ui form">
                  <h4 className="ui dividing header">Document Delivery Note</h4>
                  <div className="three fields">
                    {/*<Dropdown*/}
                    {/*    label={"Module"}*/}
                    {/*    options={moduleOptions}*/}
                    {/*    onChange={(e, data) => {setModule(data.value)}}*/}
                    {/*    value={module}*/}
                    {/*/>*/}
                    <Dropdown
                      required={true}
                      label={"Document Type"}
                      options={documentTypeOptions}
                      error={errors.documentType}
                      resetError={(errors) =>
                        setErrors({ ...errors, documentType: undefined })
                      }
                      onChange={(e, data) => {
                        console.log("the data:  ", data.value);
                        setDocumentType(data.value);
                        setCustomer(null);
                        setResetSearchFields(true);
                        setGenerateClicked(false);
                        setSelectedRows([]);
                      }}
                      value={documentType}
                    />
                    <Dropdown
                      label={"Document Category"}
                      options={singleBulkOptions}
                      value={documentCategory}
                      onChange={(e, data) => {
                        setDocumentCategory(data.value);
                      }}
                    />
                    <Input
                      label={"Reference No"}
                      value={referenceNo}
                      onChange={(e) => {
                        setReferenceNo(e.target.value);
                      }}
                    />
                  </div>
                  <div className="four fields">
                    <SearchDropdown
                      key={1}
                      required={documentType === 1 || documentType === 2}
                      editMode={false}
                      reset={resetSearchFields}
                      setReset={setResetSearchFields}
                      error={errors.stakeholder}
                      resetError={(errors) =>
                        setErrors({ ...errors, stakeholder: undefined })
                      }
                      onResultSelect={(data) => setCustomer(data)}
                      api={getOtherRefSearchDropdown}
                      apiDependency={{
                        type: "stakeholder_type",
                        value:
                          documentType === 1
                            ? "Invoicee Customer"
                            : documentType === 2
                              ? "Transporter"
                              : "Requesting Customer",
                      }}
                      fieldInfo={{
                        tableName: "masterdata.tms_m_stakeholder",
                        primaryKey: "stk_id",
                        fieldName: "stk_name",
                        id: customer,
                      }}
                      label={
                        documentType === 1
                          ? "Invoice Customer"
                          : documentType === 2
                            ? "Transporter"
                            : "Stakeholder"
                      }
                    />
                    <Dropdown
                      label={"Date Type"}
                      options={dateTypeOptions}
                      value={dateType}
                      onChange={(e, data) => {
                        setDateType(data.value);
                      }}
                    />
                    <Input
                      label="From Date"
                      type="date"
                      name="fromDate"
                      value={fromDate}
                      onChange={(e) => {
                        setFromDate(e.target.value);
                      }}
                    />
                    <Input
                      label={"To Date"}
                      type="date"
                      name="toDate"
                      value={toDate}
                      onChange={(e) => {
                        setToDate(e.target.value);
                      }}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className="field" style={{ width: "100%" }}>
                      <Button template="search" onClick={handleGenerate} />
                      <Button template="searchReset" onClick={handleReset} />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ display: tab === 2 ? "block" : "none" }}
          >
            <div
              className="ui styled accordion"
              style={{ width: "100%", marginBottom: "10px" }}
            >
              <div className={`title ${activeAccordion === 2 ? "active" : ""}`}>
                <div>
                  Search
                  <File size={14} style={{ marginLeft: "10px" }} />
                  <i className="dropdown icon"></i>
                </div>
              </div>
              <div
                className={`content ${activeAccordion === 2 ? "active" : ""}`}
              >
                <form className="ui form">
                  <h4 className="ui dividing header">Search DDNs</h4>
                  <div className="three fields">
                    {/*<Dropdown*/}
                    {/*    label={"Module"}*/}
                    {/*    options={moduleOptions}*/}
                    {/*    onChange={(e, data) => {setModule(data.value)}}*/}
                    {/*    value={module}*/}
                    {/*/>*/}
                    <Dropdown
                      required={true}
                      label={"Document Type"}
                      options={documentTypeOptions}
                      error={errors.documentTypeDDN}
                      resetError={(errors) =>
                        setErrors({ ...errors, documentTypeDDN: undefined })
                      }
                      onChange={(e, data) => {
                        setDocumentTypeDDN(data.value);
                        setSearchClicked(false);
                      }}
                      value={documentTypeDDN}
                    />
                    <SearchDropdown
                      key={1}
                      required={false}
                      editMode={false}
                      reset={resetSearchFields}
                      setReset={setResetSearchFields}
                      error={errors.stakeholderDDN}
                      resetError={(errors) =>
                        setErrors({ ...errors, stakeholderDDN: undefined })
                      }
                      onResultSelect={(data) => setDDNCustomer(data)}
                      api={getOtherRefSearchDropdown}
                      apiDependency={{
                        type: "stakeholder_type",
                        value:
                          documentTypeDDN === 1
                            ? "Requesting Customer"
                            : documentTypeDDN === 2
                              ? "Transporter"
                              : "Requesting Customer",
                      }}
                      fieldInfo={{
                        tableName: "masterdata.tms_m_stakeholder",
                        primaryKey: "stk_id",
                        fieldName: "stk_name",
                        id: ddnCustomer,
                      }}
                      label={
                        documentTypeDDN === 1
                          ? "Requesting Customer"
                          : documentTypeDDN === 2
                            ? "Transporter"
                            : "Stakeholder"
                      }
                    />
                    <Input
                      label={"Reference No"}
                      value={referenceNoDDN}
                      onChange={(e) => {
                        setReferenceNoDDN(e.target.value);
                      }}
                    />
                  </div>
                  <div className="three fields">
                    <Dropdown
                      label={"Date Type"}
                      options={dateTypeOptions}
                      value={dateTypeDDN}
                      onChange={(e, data) => {
                        setDateTypeDDN(data.value);
                      }}
                    />
                    <Input
                      label="From Date"
                      type="date"
                      name="fromDate"
                      value={fromDateDDN}
                      onChange={(e) => {
                        setFromDateDDN(e.target.value);
                      }}
                    />
                    <Input
                      label={"To Date"}
                      type="date"
                      name="toDate"
                      value={toDateDDN}
                      onChange={(e) => {
                        setToDateDDN(e.target.value);
                      }}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className="field" style={{ width: "100%" }}>
                      <Button template="search" onClick={handleSearch} />
                      <Button template="searchReset" onClick={handleReset} />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {generateClicked &&
            (isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Grid
                  ref={gridRef}
                  content={generateResult}
                  config={[
                    {
                      headerName: "Reference No",
                      field: "eihcode",
                      headerCheckboxSelection: true,
                      checkboxSelection: true,
                    },
                    {
                      headerName: "Invoice Party",
                      field: "invCustomer",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Document Category",
                      field: "eihsingle_bulk_desc",
                    },
                    {
                      headerName: "Created Date",
                      field: "createddate",
                      cellRenderer: DateCellRenderer,
                    },
                    { headerName: "Job No", field: "eihjob_no", cellRenderer: ResizableScrollingTextRenderer },
                    { headerName: "Created By", field: "createdby" },
                  ]}
                  pagination={true}
                  multiRowSelection={true}
                  onSelectionChanged={handleSelectionChanged}
                />
              </>
            ))}
          {searchClicked &&
            (isLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                heading="Document Delivery Note"
                downloadParam={""}
                downloadAction="DDN Excel Download"
                content={searchResult}
                config={[
                  {
                    headerName: "DDN Code",
                    field: "ddnCode",
                    headerCheckboxSelection: true,
                    checkboxSelection: true,
                  },
                  {
                    headerName:
                      documentTypeDDN === 2 ? "Transporter" : "Stakeholder",
                    field:
                      documentTypeDDN === 2
                        ? "transporterName"
                        : "customerName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Reference Nos",
                    field: "invoiceCodes",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Attention Person",
                    field: "ddnAttentionPerson",
                  },
                  {
                    headerName: "Document Type",
                    field: "documentTypes",
                    valueGetter: (params) => {
                      switch (params.data.documentTypes) {
                        case "1":
                          return "Invoice";
                        case "2":
                          return "EV";
                        case "3":
                          return "Credit Note";
                        case "4":
                          return "Debit Note";
                        default:
                          return "Unknown";
                      }
                    },
                  },
                  {
                    headerName: "Total",
                    field: "ddnTotal",
                    valueGetter: (params) => {
                      const value = params.data?.ddnTotal;
                      if (value === null || value === undefined || value === "")
                        return "N/A";
                      const num = Number(value);
                      if (isNaN(num)) return "N/A";
                      return num.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      });
                    },
                  },
                  { headerName: "Created By", field: "ddnCreatedBy" },
                  {
                    headerName: "Last Modified By",
                    field: "ddnLastModifiedBy",
                    valueGetter: (params) =>
                      params.data.ddnLastModifiedBy
                        ? params.data.ddnLastModifiedBy
                        : "N/A",
                  },
                  {
                    headerName: "Last Modified Date",
                    field: "ddnLastModifiedDate",
                    cellRenderer: DateCellRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "ddnStatus",
                    cellRenderer: (params) => {
                      let statusText;
                      const statusValue = Number(params.value);
                      switch (statusValue) {
                        case 1:
                          statusText = "pending";
                          break;
                        case 2:
                          statusText = "approved";
                          break;
                        case 3:
                          statusText = "rejected";
                          break;
                        default:
                          statusText = "Unknown";
                      }
                      return StatusCellStyle({ ...params, value: statusText });
                    },
                  },
                ]}
                showDownloadButton={true}
                downloadOnlySelected={true}
                multiRowSelection={true}
                reportName="document_delievery_note_report.csv"
                onCellDoubleClicked={handleRowDoubleClick}
              />
            ))}
          {selectedRows.length > 0 && generateClicked && (
            <form className="ui form segment">
              <h4 className="ui dividing header">Action</h4>
              <div
                className="three fields"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Input
                  required={true}
                  label={"Attention Person"}
                  value={attentionPerson}
                  error={errors.attentionPerson}
                  resetError={(errors) =>
                    setErrors({ ...errors, attentionPerson: undefined })
                  }
                  onChange={(e) => setAttentionPerson(e.target.value)}
                />
                <Input
                  required={true}
                  label={"Email"}
                  value={email}
                  error={errors.email}
                  resetError={(errors) =>
                    setErrors({ ...errors, email: undefined })
                  }
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Input
                  label={"Description"}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                <div>
                  <Button
                    template={"create"}
                    style={{ marginTop: "15px" }}
                    onClick={handleSubmitGenerate}
                  />
                </div>
              </div>
            </form>
          )}
          <SideDrawer
            open={isDrawerOpen}
            handleDrawerClose={handleDrawerClose}
            head={
              <div className="drawer-header">
                <h3>Document Delivery Note</h3>
              </div>
            }
            body={
              <DocumentDeliveryNoteDrawer
                resultSet={byIdResult}
                onClose={handleDrawerClose}
              />
            }
            style={{ width: "90vw" }}
          />
        </CardContent>
      </Card>
    </>
  );
}

export default DocumentDeliveryNote;
